import Immutable from 'seamless-immutable';

import { get } from 'js-cookie';
import { Cookie } from 'next-cookie';

export const getToken = (state) => {
  return (
    new Cookie().get('customer.token') ||
    get('customer.token', { domain: Immutable(state || {}).getIn(['app', 'config', 'domain']) }) ||
    state.customer.token ||
    null
  );
};

export default getToken;
